import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "@/utils/rem"
import "@/assets/fontSize/阿里巴巴普惠体/index.css"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueLazyload from 'vue-lazyload'

// Vue.use(VueLazyload,{
//   // 设置懒加载时的占位图
//   loading: '@/assets/image/',
//   // 设置图片加载失败时的占位图
//   error: 'path/to/error-image.png'
// })
Vue.use(VueLazyload, {
  //参数配置 可不填
  
  // 懒加载默认加载图片
  loading: '../assets/image/loading.png',
  // 加载失败后加载的图片
  error: '../assets/image/loading.png',
  preLoad: 1.3, // 预加载高度的比例
  attempt: 3 // 尝试加载次数
})


import VueAMap from 'vue-amap'
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
	key: '6383372f548d9f693d2a3e4e59bb7b99',// 高德的key
	// 插件集合
	plugin: [
		'AMap.CircleEditor',// 圆形编辑器插件
		"AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
		"AMap.Geocoder", // 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
		"AMap.Autocomplete",
		"AMap.PlaceSearch",
		"AMap.CitySearch",
	],
	// 高德 sdk 版本，默认为 1.4.4
	v: '1.4.4'
});
//高德的安全密钥
window._AMapSecurityConfig = {
	securityJsCode:'3e986121baa2c47baf50637caac49e31',
}





Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
